import CreateSpinSessionViewContainer from './CreateSpinSessionViewContainer';
export default CreateSpinSessionViewContainer;
